import React, { Component } from "react";
import emailjs from 'emailjs-com';
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import PaymentModal from "../elements/callaction/PaymentModal";


class ServiceDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          showModal: false,
          selectedService: "",
          name: "",
          email: "",
          phone: "",
          paymentLink: ""
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    handlePaymentClick = (service, link, collectData) => {
        if (collectData) {
            this.setState({ showModal: true, selectedService: service, paymentLink: link });
        } else {
            window.open(link, "_blank");
        }
    };
    
    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleSubmit = (event) => {
        event.preventDefault();
        
        const { name, email, phone, paymentLink } = this.state;
        
        if (!name || !email || !phone) {
            alert("Please fill in all fields before proceeding.");
            return;
        }

        const templateParams = {
            from_name: name,
            from_email: email,
            phone_number: phone,
            service_name: "Stumbling Towards Clarity",
            payment_link: paymentLink,
        };
          
        emailjs.send('30n55zb', 'template_07g0ktb', templateParams, 'mznTwnc4RFD-CG9XN')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                // Redirect to payment page
                window.open(paymentLink, "_blank");
                    
                // Close the modal
                this.setState({ showModal: false });
            })
            .catch((err) => {
                console.error('FAILED...', err);
                alert('FAILED...', err);
            });
    };
    render(){
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Service Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190"  data-black-overlay="10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Stumbling Towards Clarity</h2>
                                    <p>Life does not come with a map, but this book might be the next best thing</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content pb--80 align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/about/book.jpeg" alt="Stumbling Towards Clarity"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>
                                                        Dear Reader,<br /><br />
                                                        
                                                        Have you ever felt like you are stumbling through life, searching for meaning, direction, or just a little bit of peace? Do you find yourself caught in cycles of self-doubt, uncertainty, or emotionally overwhelmed, wondering if you will ever truly figure things out?<br /><br />

                                                        You are not alone. Life is messy, unpredictable, and often does not go according to plan. But what if I told you that within all the chaos, there are unexpected lessons, quiet truths, and moments of clarity waiting to be uncovered?<br /><br />

                                                        That’s what Stumbling Towards Clarity is all about.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-8 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h5 className="title mt-3">Why This Book? Why Now?</h5>
                                                    <p>
                                                        The world is louder, faster, and more demanding than ever before. We are all trying to keep up, to make sense of our emotions, relationships, and ambitions while juggling the weight of expectations, both our own and those imposed by society.<br /><br />
                                                    </p>

                                                    <h6 className="title">This book was written for:</h6>
                                                    <ul className="liststyle">
                                                        <li>The dreamers and seekers—those who know they are meant for more but are not quite sure what “more” looks like.</li>
                                                        <li>The overthinkers and perfectionists—who feel paralysed by the fear of failure or making the wrong move.</li>
                                                        <li>Those navigating transitions—whether it is heartbreak, career shifts, loss, or rediscovering themselves after years of feeling lost.</li>
                                                        <li>Anyone craving deeper connections—to themselves, to others, and to the world around them.</li>
                                                    </ul>

                                                    <p className="mt-2">
                                                        If any of this resonates with you, then Stumbling Towards Clarity is not just a book, it is the mirror, the companion, and the gentle nudge forward that you have been searching for.<br /><br />
                                                    </p>

                                                    <h5 className="title mt-3">What’s Inside?</h5>
                                                    <p className="mt-2">
                                                        A Blend of Personal Essays, Poetry, and Reflection – Crafted to speak to the heart and mind, bringing real, lived experiences into focus.<br /><br />

                                                        Deep Dives into Life’s Big Questions – How do we find purpose, peace, and meaning in a world that often feels chaotic?<br /><br />

                                                        Practical Wisdom and Real Talk – it is not about having all the answers, it is about learning to ask the right questions.<br /><br />

                                                        A Warm, Conversational Tone – Like sitting down with an old friend who just gets what you are going through.<br /><br />
                                                    </p>

                                                    <h6 className="title">Themes That Matter:</h6>
                                                    <ul className="liststyle">
                                                        <li>Self-discovery – Who am I, really?</li>
                                                        <li>Resilience and  emotional well-being – How do I stop letting setbacks define me?</li>
                                                        <li>Faith and hope – Can I trust that things will get better?</li>
                                                        <li>Love and relationships – How do I build deeper, more meaningful connections?</li>
                                                        <li>Overcoming fear and self-doubt – Am I truly capable of the life I dream of?</li>
                                                    </ul>

                                                    <p>
                                                        This is not just another self-help book telling you what to do,it is an invitation to slow down, reflect, and uncover your answers.<br /><br />
                                                    </p>

                                                    <h5 className="title mt-3">Why I Wrote This Book</h5>
                                                    <p>Because I have been there.</p>
                                                    
                                                    <p>I have stumbled through the darkness, wrestled with uncertainty, and questioned my worth. I have had moments of loss, failure, and heartbreak that left me wondering if I would ever find my way again.</p>

                                                    <p>And through it all, I realised something: clarity is not something you find all at once. It is something you stumble towards, step by step, experience by experience.</p>

                                                    <p>I wrote this book because I wanted to share the lessons I have learned, the insights that shifted my perspective, and the hope that carried me through even my hardest days.</p>

                                                    <p>And more than anything, I wrote it for you, because I know what it is like to feel lost. And I want you to know that you are never truly alone on this journey.</p>

                                                    <h5 className="title mt-3">Available Now:</h5>
                                                    
                                                    <h5 className="text-italic">Get your Copy!</h5>
                                                    
                                                    <div className="payment-buttons mt-3">
                                                        <img
                                                            src="/assets/images/icons/amazon.png"
                                                            alt="Amazon"
                                                            className="btn-icon clickable mr-5"
                                                            height={"25rem"}
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => this.handlePaymentClick("Stumbling Towards Clarity", "https://www.amazon.com/dp/B0F3YTCMT4?ref_=pe_93986420_774957520", true)}
                                                        />
                                                        <img
                                                            src="/assets/images/icons/selar.png"
                                                            alt="Selar"
                                                            className="btn-icon clickable mr-5"
                                                            height={"50rem"}
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => this.handlePaymentClick("Stumbling Towards Clarity", "https://selar.com/17w91z", false)}
                                                        />
                                                        <img
                                                            src="/assets/images/icons/mainstack.png"
                                                            alt="Mainstack"
                                                            className="btn-icon clickable mr-5"
                                                            height={"25rem"}
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => this.handlePaymentClick("Stumbling Towards Clarity", "https://mainstack.store/coachdoi/-y6q_tjLYA7O", false)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                <PaymentModal
                    show={this.state.showModal}
                    onClose={() => this.setState({ showModal: false })}
                    onSubmit={this.handleSubmit}
                    name={this.state.rnName}
                    email={this.state.rnEmail}
                    phone={this.state.rnPhone}
                    service={this.state.selectedService}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                />
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />

            </React.Fragment>
        )
    }
}
export default ServiceDetails;